import React from 'react'
import ExpiredSubscriptionSvg from 'assets/images/expired-subscription.svg'
import Button from 'components/ui/button'
import ContactUsLink from 'components/ui/contact-us-link'
import DiscoModal from 'components/ui/disco-modal'
import Heading from 'components/ui/heading'
import modalStyles from 'components/utils/modalStyles'
import styles from './index.module.css'

/**
 * Blocking modal shown when the business subscription has expired.
 * @param href - Restart link (Chargebee hosted pricing page), opened in a new tab
 * @param onClose - Called when the restart button is clicked or the modal is dismissed
 * @param contactSupport - Replaces the restart button with a support chat, for plans that can't be restarted self-serve
 */
const ExpiredSubscriptionModal = ({
  href,
  onClose,
  contactSupport = false,
}: {
  href?: string
  onClose?: (...args: Array<any>) => any
  contactSupport?: boolean
}): React.ReactNode => (
  <DiscoModal isOpen style={modalStyles} onRequestClose={onClose}>
    <div className={styles.expiredSubscriptionModal}>
      <ExpiredSubscriptionSvg className={styles.expiredSubscriptionModalSvg} />
      <Heading size="600">Your subscription has expired</Heading>
      {contactSupport ? (
        <>
          <p className={styles.expiredSubscriptionModalDescription}>
            To restart your subscription, please chat to our support team.
          </p>
          <ContactUsLink
            type="button"
            intercomMsg="My subscription has expired and I’d like to restart it"
            dataTestId="expired-subscription-contact-support"
          >
            Contact Support
          </ContactUsLink>
        </>
      ) : (
        <>
          <p className={styles.expiredSubscriptionModalDescription}>
            To restart your subscription, click the button below.
          </p>
          <Button
            caption="Restart Subscription"
            appearance="primary"
            disabled={!(href || onClose)}
            link={href}
            linkTarget="_blank"
            onClick={onClose}
          />
        </>
      )}
    </div>
  </DiscoModal>
)

export default ExpiredSubscriptionModal
